import { render } from "./WatchButtonCda.vue?vue&type=template&id=7aec3922&scoped=true"
import script from "./WatchButtonCda.vue?vue&type=script&lang=js"
export * from "./WatchButtonCda.vue?vue&type=script&lang=js"

import "./WatchButtonCda.vue?vue&type=style&index=0&id=7aec3922&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aec3922"]])

export default __exports__